import clsx from "clsx";

export default function Input({
  value, onChange, placeholder, type = "text", icon,
  className = "", error, label, hint, ...props
}) {
  return (
    <div className={clsx("space-y-1", className)}>
      {label && <label className="block text-xs font-bold text-gray-400 uppercase tracking-wider">{label}</label>}
      <div className="relative">
        {icon && (
          <span className="absolute left-3.5 top-1/2 -translate-y-1/2 text-base opacity-50 pointer-events-none">{icon}</span>
        )}
        <input
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          type={type}
          className={clsx(
            "w-full rounded-xl bg-nexus-s2 border text-white placeholder-gray-600 font-medium text-sm",
            "transition-all duration-200 outline-none py-3",
            "focus:border-violet-500 focus:ring-2 focus:ring-violet-500/20",
            icon ? "pl-10 pr-4" : "px-4",
            error ? "border-red-500/60" : "border-nexus-border"
          )}
          {...props}
        />
      </div>
      {error && <p className="text-xs text-red-400 font-medium">{error}</p>}
      {hint && !error && <p className="text-xs text-gray-500">{hint}</p>}
    </div>
  );
}
